'use client';

import { useState, useCallback } from 'react';

const sectors = [
  {
    name: 'Automotive',
    description: 'Prototipi funzionali per test e validazioni, componenti per interni ed esterni, condotti aria e parti sotto cofano resistenti a calore e vibrazioni.',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
      </svg>
    ),
  },
  {
    name: 'Aerospaziale',
    description: 'Componenti leggeri ad alte prestazioni, staffe strutturali, condotti aria e parti certificate per il settore aeronautico e spaziale.',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
      </svg>
    ),
  },
  {
    name: 'Medicina',
    description: 'Modelli anatomici per la pianificazione chirurgica, guide personalizzate, protesi su misura e dispositivi medicali.',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
      </svg>
    ),
  },
  {
    name: 'Robotica',
    description: 'Componenti custom per robot e automazione: involucri, ingranaggi, end-effector e parti strutturali su misura.',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6.75v10.5a2.25 2.25 0 002.25 2.25zm.75-12h9v9h-9v-9z" />
      </svg>
    ),
  },
  {
    name: 'Architettura',
    description: 'Plastici e modelli in scala ad alta fedeltà, elementi decorativi, studi volumetrici e prototipi per presentazioni.',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3H21m-3.75 3H21" />
      </svg>
    ),
  },
  {
    name: 'Arte e Design',
    description: 'Sculture, installazioni artistiche, oggetti di design, prototipi di prodotto e pezzi unici personalizzati.',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42" />
      </svg>
    ),
  },
  {
    name: 'Elettronica',
    description: 'Involucri e custodie custom, dissipatori termici, connettori, supporti per PCB e parti per dispositivi elettronici.',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6.75v10.5a2.25 2.25 0 002.25 2.25zm.75-12h9v9h-9v-9z" />
      </svg>
    ),
  },
  {
    name: 'Istruzione',
    description: 'Kit didattici, modelli anatomici e molecolari, prototipi per laboratori scolastici e progetti STEM.',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
      </svg>
    ),
  },
];

const N = sectors.length;
const STEP = 360 / N;
const R = 145;
const ICON_SIZE = 50;

export default function Sectors() {
  const [rotation, setRotation] = useState(0);
  const selected = ((Math.round(-rotation / STEP) % N) + N) % N;

  const goTo = useCallback((i: number) => {
    setRotation(prev => {
      const currentIdx = ((Math.round(-prev / STEP) % N) + N) % N;
      let diff = i - currentIdx;
      if (diff > N / 2) diff -= N;
      if (diff < -N / 2) diff += N;
      return prev - diff * STEP;
    });
  }, []);

  const prev = () => setRotation(r => r + STEP);
  const next = () => setRotation(r => r - STEP);

  return (
    <section className="py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <div className="grid lg:grid-cols-[auto_1fr] gap-8 lg:gap-16 items-center">

          {/* Orbit */}
          <div
            className="relative mx-auto flex items-center justify-center"
            style={{ width: R * 2 + ICON_SIZE + 20, height: R * 2 + ICON_SIZE + 20 }}
          >
            {/* Orbit ring */}
            <svg
              className="absolute inset-0 w-full h-full"
              viewBox={`0 0 ${R * 2 + ICON_SIZE + 20} ${R * 2 + ICON_SIZE + 20}`}
              fill="none"
            >
              <circle
                cx="50%"
                cy="50%"
                r={R}
                stroke="#e5e7eb"
                strokeWidth="1.5"
                strokeDasharray="6 4"
                opacity="0.6"
              />
            </svg>

            {/* Selection indicator — right side of orbit */}
            <div
              className="absolute z-20 flex items-center"
              style={{
                left: '50%',
                top: '50%',
                transform: `translate(${R + ICON_SIZE / 2 + 6}px, -50%)`,
              }}
            >
              <svg width="10" height="20" viewBox="0 0 10 20" fill="none">
                <path d="M2 2 L8 10 L2 18" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>

            {/* Rotating container */}
            <div
              className="absolute inset-0"
              style={{
                transform: `rotate(${rotation}deg)`,
                transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            >
              {sectors.map((s, i) => {
                const angle = i * STEP;
                const isActive = i === selected;

                return (
                  <button
                    key={s.name}
                    onClick={() => goTo(i)}
                    className="absolute"
                    style={{
                      top: '50%',
                      left: '50%',
                      width: ICON_SIZE,
                      height: ICON_SIZE,
                      marginTop: -ICON_SIZE / 2,
                      marginLeft: -ICON_SIZE / 2,
                      transform: `rotate(${angle}deg) translateX(${R}px) rotate(${-(angle + rotation)}deg)`,
                      transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
                      zIndex: isActive ? 10 : 1,
                    }}
                    aria-label={s.name}
                  >
                    <div
                      className={`
                        w-full h-full rounded-2xl flex items-center justify-center
                        transition-all duration-500
                        ${isActive
                          ? 'bg-primary-600 text-white scale-[1.15] shadow-xl shadow-primary-500/30 ring-4 ring-primary-200'
                          : 'bg-white text-secondary-400 border border-secondary-200 hover:border-secondary-300 hover:text-secondary-500 hover:shadow-md'
                        }
                      `}
                    >
                      {s.icon}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Text content */}
          <div className="text-center lg:text-left">
            <p className="text-sm font-semibold text-primary-600 uppercase tracking-wider mb-3">
              Settori di applicazione
            </p>
            <h2 className="text-3xl md:text-4xl font-display font-bold text-secondary-500 mb-4 leading-tight min-h-[2.5em]">
              <span key={selected} className="inline-block animate-fade-in">
                {sectors[selected].name}
              </span>
            </h2>
            <p
              key={`desc-${selected}`}
              className="text-secondary-400 leading-relaxed mb-8 max-w-md mx-auto lg:mx-0 min-h-[4em] animate-fade-in"
            >
              {sectors[selected].description}
            </p>

            <p className="text-secondary-400 leading-relaxed mb-8 max-w-md mx-auto lg:mx-0">
              La stampa 3D trova applicazione in ogni settore dove servono
              prototipi rapidi, parti personalizzate o geometrie impossibili
              da realizzare con metodi tradizionali.
            </p>

            {/* Navigation */}
            <div className="flex items-center gap-4 justify-center lg:justify-start">
              <button
                onClick={prev}
                className="w-11 h-11 rounded-full border border-secondary-200 flex items-center justify-center text-secondary-400 hover:border-primary-300 hover:text-primary-500 hover:bg-primary-50 transition-all duration-200"
                aria-label="Settore precedente"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              <span className="text-sm text-secondary-400 font-medium tabular-nums w-10 text-center">
                {selected + 1}/{N}
              </span>

              <button
                onClick={next}
                className="w-11 h-11 rounded-full border border-secondary-200 flex items-center justify-center text-secondary-400 hover:border-primary-300 hover:text-primary-500 hover:bg-primary-50 transition-all duration-200"
                aria-label="Settore successivo"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
